import GoogleTraffic from './GoogleTraffic';
import MessageSigns from './MessageSigns';
import Incidents from './Incidents';
import Roadwork from './Roadwork';
import TravelTimes from './TravelTimes';
import Cameras from './Cameras';
import Snowplows from './Snowplows';
import SnowplowRoutes from './SnowplowRoutes';
import { ModuleConfig } from '@schamburg-web/interfaces';

const definedModules: ModuleConfig[] = [
  Incidents,
  TravelTimes,
  Roadwork,
  Cameras,
  Snowplows,
  MessageSigns,
  SnowplowRoutes,
  GoogleTraffic,
];

export default definedModules;
